import {
    section,
    mrAuto,
    mlAuto,
    title,
    container,
    description,
    cardTitle,
    coloredShadow
} from "../../../material-kit-pro-react";

const overviewStyle = {
    mrAuto,
    mlAuto,
    title,
    container,
    description: {
        ...description,
        marginBottom: "70px"
    },
    section: {
        ...section,
        padding: "70px 0px"
    },
    sectionTestimonials: {
        paddingTop: "30px",
        paddingBottom: "50px",
        textAlign: "center",
        "& $cardTitle": {
            marginTop: "0px"
        }
    },
    features5: {
        ...section,
        backgroundRepeat: "no-repeat",
        position: "relative",
        padding: "80px 0px",
        textAlign: "center",
        "& $title": {
            zIndex: "2",
            position: "relative",
            marginBottom: "30px",
            color: "#fff"
        },
        "& p": {
            color: "#fff"
        },
        "&:after": {
            background: "rgba(0,0,0,0.65)",
            position: "absolute",
            width: "100%",
            height: "100%",
            content: "''",
            zIndex: "0",
            left: "0px",
            top: "0px"
        }
    },
    features: {
        textAlign: "center",
        paddingTop: "30px",
        pddingBottom: "0px"
    },
    featuresShow: {
        zIndex: 3,
        border: "1px solid rgba(255,255,255,0.35)",
        borderTop: 0,
        borderBottom: 0,
        "&:last-of-type": {
            borderRight: 0
        },
        "&:first-of-type": {
            borderLeft: 0
        },
        "& h4,& p,& svg,& .fab,& .fas,& .far,& .fal,& .material-icons": {
            color: "#fff"
        },
        "& p": {
            lineHeight: "24px",
            fontSize: "16px"
        }
    },
    ourClients: {
        textAlign: "center",
        "& img": {
            width: "100%",
            maxWidth: "140px",
            margin: "0 auto",
            display: "inline-block"
        }
    },
    cardTitle: {
        ...cardTitle,
        marginTop: 0
    },
    cardDescription: {
        fontSize: "16px",
        lineHeight: "1.6em",
        color: "#999"
    },
    coloredShadow,
    alignLeft: {
        textAlign: "left"
    },


    paymentMethods: {
        paddingTop: "30px",
        paddingBottom: "10px",
        textAlign: "center",
        "& $cardTitle": {
            marginTop: "0px"
        }
    },
    paymentsImg: {
        marginTop: "20px",
        width: "100%"
    },


    modalRoot: {
        overflow: "auto",
        display: "block"
    },
    modal: {
        maxWidth: "500px",
        margin: "1.75rem auto",
        borderRadius: "6px",
        overflow: "visible",
        maxHeight: "unset",
        width: "100%",
        marginTop: "130px !important"
    },
    modalHeader: {
        borderBottom: "none",
        paddingTop: "24px",
        paddingRight: "24px",
        paddingBottom: "0",
        paddingLeft: "24px",
        minHeight: "16.43px"
    },
    modalCloseButton: {
        "&, &:hover": {
            color: "#999999"
        },
        "&:hover": {
            opacity: "1"
        },
        cursor: "pointer",
        padding: "1rem",
        margin: "-1rem -1rem -1rem auto",
        backgroundColor: "transparent",
        border: "0",
        WebkitAppearance: "none",
        float: "right",
        fontSize: "1.5rem",
        fontWeight: "500",
        lineHeight: "1",
        textShadow: "0 1px 0 #ffffff",
        opacity: ".5"
    },
    modalClose: {
        width: "16px",
        height: "16px"
    },
    modalTitle: {
        margin: "0",
        lineHeight: "1.5"
    },
    modalBody: {
        paddingTop: "24px",
        paddingRight: "24px",
        paddingBottom: "16px",
        paddingLeft: "24px",
        position: "relative",
        overflow: "visible"
    },
};

export default overviewStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-kit-pro-react/views/presentationSections/overviewStyle.jsx